import React from 'react';
import { Helmet } from 'react-helmet-async';
import metaData from '../constants/metaData.json';
import { get } from 'lodash';

export default function SeoComponent(props) {
  const { page } = props;
  const pageMetaData = get(metaData, page);
  return (
    <>
      <Helmet>
        <title>{get(pageMetaData, 'title')}</title>
        <meta name='description' content={get(pageMetaData, 'description')} />
        <link rel='canonical' href={get(pageMetaData, 'canonical')} />

        <meta property='og:title' content={get(pageMetaData, 'title')} />
        <meta
          property='og:description'
          content={get(pageMetaData, 'description')}
        />
        <meta property='og:image' content={get(pageMetaData, 'image')} />
        <meta property='og:url' content={get(pageMetaData, 'canonical')} />
        <meta property='og:type' content='website' />

        <meta name='twitter:card' content='summary_large_image' />
        <meta name='twitter:title' content={get(pageMetaData, 'title')} />
        <meta
          name='twitter:description'
          content={get(pageMetaData, 'description')}
        />
        <meta name='twitter:image' content={get(pageMetaData, 'image')} />
        <meta name='twitter:site' content='@Cypher_HQ_' />

        <meta name='viewport' content='width=device-width, initial-scale=1' />
        <meta name='author' content='CypherHQ Team' />
        <meta charset='UTF-8' />
      </Helmet>
    </>
  );
}
